import { useContext } from 'react';
import { TransactionContext } from '@/providers/TransactionProvider/TransactionProvider';

/**
 * Custom hook to access the AirKey transaction information
 * @returns The transaction context value.
 */
export function useTransaction() {
  const context = useContext(TransactionContext);
  if (!context) {
    throw new Error('useTransaction must be used within a TransactionProvider');
  }
  return context;
}
